module.exports = __webpack_public_path__ + "img/prediction_generate_setup.cda0d2d0.png";